<template>
  <section header>
    <span :class="$style.offerHeader">Offers</span>
  </section>
  <DataTable :value="props.configData" :class="$style.offerConfigVisualizer">
    <Column field="campaign" header="Campaign" :header-class="$style.columnHeader" />
    <Column field="name" header="Offer" :header-class="$style.columnHeader">
      <template #body="rowProps">
        <span :class="$style.offerName">{{ rowProps.data.name }}</span>
        <span :class="$style.offerId">{{ rowProps.data.id }}</span>
      </template>
    </Column>
    <Column field="type" header="Type" :header-class="$style.columnHeader">
      <template #body="rowProps">
        <Tag :value="tagValueForOffer(rowProps.data)" :class="tagClassForOffer(rowProps.data)" />
      </template>
    </Column>
  </DataTable>
</template>
<script setup lang="ts">
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Tag from "primevue/tag";
import { SimulationOffer } from "@/modules/Simulation/types";
import { OfferType } from "@/graphql";
import { useCssModule } from "vue";

const $style = useCssModule();
const props = defineProps<{
  configData: SimulationOffer[];
}>();

const tagValueForOffer = (offer: SimulationOffer) => {
  switch (offer.type) {
    case OfferType.Npo:
      return offer.isEndless ? "Endless" : "Chained";
    case OfferType.Spin:
      return "Wheel";
    default:
      return offer.type;
  }
};

const tagClassForOffer = (offer: SimulationOffer) => {
  switch (offer.type) {
    case "1PO":
      return $style.onePoTag;
    case "2PO":
      return $style.twoPoTag;
    case "3PO":
      return $style.threePoTag;
    case OfferType.Npo:
      return offer.isEndless ? $style.endlessTag : $style.chainedTag;
    case OfferType.Spin:
      return $style.wheelTag;
    default:
      return "";
  }
};
</script>
<style module lang="scss">
.onePoTag {
  background-color: #3b82f6;
}

.twoPoTag {
  background-color: #14b8a6;
}

.threePoTag {
  background-color: #6366f1;
}

.wheelTag {
  background: #0ea5e9;
}

.endlessTag {
  background-color: #ec4899;
}

.chainedTag {
  background-color: #a855f7;
}

.offerHeader {
  font-size: 16px;
  display: block;
  margin: 10px 10px 10px 0;
  font-weight: 600;
  color: $intense-blue;
}

.offerConfigVisualizer {
  .p-datatable-table {
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    border-width: 1px 1px 0 1px;

    .columnHeader {
      background: #f9fafb;
    }
  }

  .offerName {
    display: block;
  }

  .offerId {
    color: #909298;
  }

  .p-datatable-table > thead > tr:first-of-type > th:first-of-type {
    border-radius: 0.5rem 0 0 0;
  }

  /* Top Right Would be: */
  .p-datatable-table > thead > tr:first-of-type > th:last-of-type {
    border-radius: 0 0.5rem 0 0;
  }

  /* Bottom Left Would Be: */
  .p-datatable-table > tbody > tr:last-of-type > td:first-of-type {
    border-radius: 0 0 0 0.5rem;
  }

  /* Bottom Right Would Be: */
  .p-datatable-table > tbody > tr:last-of-type > td:last-of-type {
    border-radius: 0 0 0.5rem 0;
  }
}
</style>
